import React from 'react'
import AdminBillingAccountDetailContext from './context'
import CashBalanceTransactionsTable from 'components/CashBalanceTransactionsTable'

const AdminBillingAccountDetailCashBalanceTransactions: React.FC = () => {
    const {
        cashBalanceTransactionSearchForm,
        updateCashBalanceTransactionSearchForm,
    } = React.useContext(AdminBillingAccountDetailContext)
    
    return (
        <CashBalanceTransactionsTable 
            form={cashBalanceTransactionSearchForm}
            updateForm={updateCashBalanceTransactionSearchForm}
        />
    )
}

export default AdminBillingAccountDetailCashBalanceTransactions